// Sprint 1 — Cover-Page Date-Format-Util.
//
// Hybrid-Strategie (Bene-Spec 2026-05-19 Q2): relativ-Deutsch wenn
// Diff < 30 Tage (via Intl.RelativeTimeFormat), sonst absolut-Deutsch
// (via Intl.DateTimeFormat). Source-of-Truth-Mockup: docs/mockups/
// extra-screens.jsx:507 zeigt "12. März 2026 · 6 Min. Lesezeit"-Format
// als Embed-Surface-Konvention.
//
// Pure Function, kein DOM-Bezug, separat testbar.

const RELATIVE_THRESHOLD_DAYS = 30;

const ABSOLUTE_FORMATTER = new Intl.DateTimeFormat("de-DE", {
  day: "numeric",
  month: "long",
  year: "numeric",
});

const RELATIVE_FORMATTER = new Intl.RelativeTimeFormat("de-DE", {
  numeric: "auto",
  style: "long",
});

/**
 * Formatiert ein Publishing-Datum hybrid: relativ wenn jünger als
 * 30 Tage, sonst absolut.
 *
 * @param iso ISO-8601 Date-String (z.B. PostBackend.publishedAt) oder Date.
 * @param now Optional, für deterministisches Testing.
 * @returns Formatted-String (z.B. "vor 3 Tagen", "19. Mai 2026").
 *          Bei invalidem Input → leerer String.
 */
export function formatScrollyDate(
  iso: string | Date | null | undefined,
  now: Date = new Date(),
): string {
  if (!iso) return "";
  const date = typeof iso === "string" ? new Date(iso) : iso;
  if (!(date instanceof Date) || Number.isNaN(date.getTime())) return "";

  const diffMs = now.getTime() - date.getTime();
  const diffDays = Math.floor(diffMs / 86_400_000);

  // Future-Datum oder ≥ 30 Tage → absolut
  if (diffDays < 0 || diffDays >= RELATIVE_THRESHOLD_DAYS) {
    return ABSOLUTE_FORMATTER.format(date);
  }

  // Relativ-Pfad (< 30 Tage)
  if (diffDays === 0) {
    const diffHours = Math.floor(diffMs / 3_600_000);
    if (diffHours === 0) {
      const diffMins = Math.floor(diffMs / 60_000);
      if (diffMins < 1) return RELATIVE_FORMATTER.format(0, "minute");
      return RELATIVE_FORMATTER.format(-diffMins, "minute");
    }
    return RELATIVE_FORMATTER.format(-diffHours, "hour");
  }
  return RELATIVE_FORMATTER.format(-diffDays, "day");
}
